import { Reveal, Eyebrow } from "./Motion";

const REASONS = [
  {
    t: "Experience & Domain Expertise",
    d: "We understand the realities of HR, the complexities of managing people and the importance of aligning workforce decisions with business needs.",
  },
  {
    t: "Digital HR. From Appointment to Exit.",
    d: "Our integrated HRMS supports the employee lifecycle from appointment to exit, bringing time and attendance, payroll and compliance into a connected system accessible through both desktop and mobile applications.",
  },
  {
    t: "Client Servicing with Accountability.",
    d: "Our client servicing team is committed to being accessible, responsive and accountable. With designated points of contact and a clear escalation matrix, we bring structure to communication, clarity to ownership and consistency to service delivery.",
  },
];

export const WhyKrimzon = () => (
  <section className="mx-auto max-w-[1400px] px-6 py-24 lg:px-12 lg:py-36" data-testid="why-section">
    <div className="grid gap-16 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>Why KRIMZON</Eyebrow>
            <h2 className="font-display mt-6 text-3xl font-bold tracking-tight text-[#0D9488] sm:text-4xl lg:text-5xl" data-testid="why-title">
              Built on experience. Driven by purpose.
            </h2>
            <p className="mt-6 text-base leading-relaxed text-[#2D6A64] md:text-lg">
              We bring nearly two decades of HR experience, deep domain expertise and a genuine passion for making HR work better.
            </p>
          </Reveal>
          <Reveal delay={0.1} className="relative mt-12">
            <div className="absolute inset-0 translate-x-3 translate-y-3 border border-[#D4AF37]/60" aria-hidden />
            <div className="clip-corner relative aspect-[4/3] overflow-hidden">
              <img src="/img/executive_meeting.jpg" alt="KRIMZON team in discussion" className="h-full w-full object-cover" />
            </div>
          </Reveal>
        </div>
      </div>
      <div className="lg:col-span-6 lg:col-start-7">
        {REASONS.map((r, i) => (
          <Reveal key={r.t} delay={0.05}>
            <div className="group border-t border-[#E2ECEB] py-10 transition-colors duration-500 hover:border-[#D4AF37] lg:py-14" data-testid={`why-reason-${i}`}>
              <span className="font-display text-sm font-semibold tracking-[0.3em] text-[#0D9488]">0{i + 1}</span>
              <h3 className="font-display mt-4 text-2xl font-bold tracking-tight text-[#0D9488] lg:text-3xl">{r.t}</h3>
              <p className="mt-4 text-base leading-relaxed text-[#2D6A64]">{r.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
    <Reveal className="mt-20 border-t border-[#D4AF37] pt-14 lg:mt-28">
      <p className="font-display max-w-5xl text-2xl font-medium leading-snug text-[#0F3D39] sm:text-3xl lg:text-4xl" data-testid="why-closing">
        We bring experience <span className="text-[#0D9488]">without the baggage</span>, technology <span className="text-[#0D9488]">without the complexity</span>, and human thinking <span className="text-[#0D9488]">without losing sight of business</span>.
      </p>
    </Reveal>
  </section>
);
